import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=6fb55fe6&"
import script from "./ClientsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb55fe6')) {
      api.createRecord('6fb55fe6', component.options)
    } else {
      api.reload('6fb55fe6', component.options)
    }
    module.hot.accept("./ClientsTable.vue?vue&type=template&id=6fb55fe6&", function () {
      api.rerender('6fb55fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tables/ClientsTable.vue"
export default component.exports